module.exports = __webpack_public_path__ + "img/services-3.e4d30d8f.jpg";